import { SummaryCard } from '../../../types';

export const dinCards: SummaryCard[] = [];